// LoadingsDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import LoadingsForm from './LoadingsForm'
import "../../css/DemoCode.css"

/**
 * Dialog for pollutant loadings.
 * 
 * @param {JSON} model A state-controlled SWMM model in JSON format.
 * @param {function} setModel state-controlled update function for updating 'model'.
 * @returns UI for interactive swmm modeling.
 */
export default function LoadingsDialog({ model, setModel, targetType, target }) {
  const [submodel, setSubmodel] = useState()
  const [pollutantIDs, setPollutantIDs]   = useState((Object.keys(model.POLLUTANTS).length===0?[]:Object.keys(model.POLLUTANTS)))
  
  // Create a submodel for this editor interface.
  useEffect(()=>{
    // Create a group of empty coverages for each type of landuse
    let LOADINGS = {[target]:{}}
    pollutantIDs.forEach((id) => 
      LOADINGS[target][id] = {
        InitLoad: '0'
      }
    )

    if(model.LOADINGS && model.LOADINGS[target]){
      LOADINGS = {
        [target]: {
          ...LOADINGS[target],
          ...model.LOADINGS[target]
        }
      }
    }

    setSubmodel({
      LOADINGS: LOADINGS
    })
  }, [])

  const saveEdits = () => {
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    setModel(prev => ({
      ...prev,
      LOADINGS:{
        ...prev.LOADINGS, 
        [target]: {
          ...cleanSub.LOADINGS[target]
        }
      }
    }))
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(submodel){
    return(
      <>
      {
        <>
          <Typography id="modal-modal-title" variant="p4" >
            <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
              <label>Initial Buildup for Subcatchment {target}</label>
            </div>
          </Typography>
          <div>
            <Button fullWidth onClick={saveEdits} >Save Edits</Button>
          </div>
          <div style={{height: "280px", background:'black', overflowY: 'scroll', paddingBottom:"120px"}}>
            {
              targetType && 
              targetType in model && 
              target &&
              <LoadingsForm model={submodel} setModel={setSubmodel} fullModel={model} target={target} />
            }
          </div>
          </>
        }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}